var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidaybell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1l6 1.5v.02l6-1.5V7.58l-3.791-.947A6.002 6.002 0 0118 12.214v5.781h2v2H4v-2h2v-5.781a6.002 6.002 0 013.943-5.638L6 7.562V1zm2 2.562V5l2-.5v-.438l-2-.5zm8 8.652v5.78H8v-5.78a4 4 0 118 0zm-5.412 10.194c.391.391.862.587 1.412.587.55 0 1.02-.196 1.412-.587.392-.392.588-.863.588-1.413h-4c0 .55.196 1.021.588 1.413zM16 5.02V3.58l-2 .5v.439l2 .5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaybell);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgMUwxMiAyLjVWMi41MTk3OEwxOCAxLjAxOTc4VjcuNTgxMzNMMTQuMjA5IDYuNjMzNTdDMTYuNDI5NSA3LjUxMzMyIDE4IDkuNjgwMiAxOCAxMi4yMTM5VjE3Ljk5NTFIMjBWMTkuOTk1MUg0VjE3Ljk5NTFINlYxMi4yMTM5QzYgOS42MjI5NSA3LjY0MjIzIDcuNDE1NTkgOS45NDI1NSA2LjU3NTkxTDYgNy41NjE1NVYxWk04IDMuNTYxNTVWNUwxMCA0LjVWNC4wNjE1NUw4IDMuNTYxNTVaTTE2IDEyLjIxMzlWMTcuOTkzOUg4VjEyLjIxMzlDOCAxMC4wMDQ3IDkuNzkwODYgOC4yMTM4NyAxMiA4LjIxMzg3QzE0LjIwOTEgOC4yMTM4NyAxNiAxMC4wMDQ3IDE2IDEyLjIxMzlaTTEwLjU4NzUgMjIuNDA3NkMxMC45NzkyIDIyLjc5OTMgMTEuNDUgMjIuOTk1MSAxMiAyMi45OTUxQzEyLjU1IDIyLjk5NTEgMTMuMDIwOCAyMi43OTkzIDEzLjQxMjUgMjIuNDA3NkMxMy44MDQyIDIyLjAxNiAxNCAyMS41NDUxIDE0IDIwLjk5NTFIMTBDMTAgMjEuNTQ1MSAxMC4xOTU4IDIyLjAxNiAxMC41ODc1IDIyLjQwNzZaTTE2IDUuMDE5NzhWMy41ODEzM0wxNCA0LjA4MTMzVjQuNTE5NzhMMTYgNS4wMTk3OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };